<template>
  <div>
    <b-input-group :title="$t('Filtros')" class="mb-2" :size="size">
      <b-input-group-prepend>
        <b-input-group-text style="border-right: 0">{{
          $t(`Filtrar${hasfields ? " por" : ""}`)
        }}</b-input-group-text>
        <b-form-select
          v-if="hasfields"
          class="groupitem"
          placeholder="Todos"
          :value="field[0]"
          :options="fieldsfilter"
          @change="$emit('oninputfield', [$event])"
        ></b-form-select>
      </b-input-group-prepend>
      <b-form-input
        type="search"
        ref="inputfilter"
        :placeholder="placeholder"
        :value="filter"
        @input="onInput($event)"
      ></b-form-input>
      <!-- @input="$emit('input', $event)" -->
      <b-input-group-append
        v-if="$slots.endbuttons && $slots.endbuttons.length > 0"
      >
        <slot name="endbuttons"></slot>
      </b-input-group-append>
    </b-input-group>

    <!--
      
      Filtro.timeoutinc: {{ timeoutinc }}<br />
      Filtro.value: {{ value }}<br />
      Filtro.filterfield: {{ filterfield }}<br />
      Filtro.fieldsfilter: {{ fieldsfilter }}<br />
      Filtro.fieldscomputed: {{ fieldscomputed }}<br />
      Filtro.filterincluded: {{ filterincluded }}<br />
      
    -->
  </div>
</template>

<script>
export default {
  name: "Filtro",
  props: {
    value: String,
    size: {
      type: String,
      default: "sm",
    },
    placeholder: {
      type: String,
      default: "Digite aqui o que deseja filtrar",
    },
    delay: {
      type: Number,
      default: 500,
    },
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    field: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      inputtimeout: null,
      timeoutinc: 0,
      filter: "",
      filterfield: this.field || [],
    };
  },
  computed: {
    hasfields() {
      return this.fields.length > 0;
    },
    fieldscomputed() {
      let fields = [];
      this.fields.map((f, i) => {
        if (typeof f === "object") {
          if (f.key !== "actions" && f.key !== "selected" && f.key !== "") {
            if (!Array.isArray(f)) {
              f.label = f.label || f.key;
              f.sortable = true;
              fields.push(f);
            }
          }
        } else {
          if (!Array.isArray(f)) {
            if (f !== "actions" && f.key !== "selected" && f !== "") {
              f = { key: f, label: f, sortable: true };
              fields.push(f);
            }
          }
        }
      });
      return fields;
      //.filter((f) => (f.key == "selected" ? this.selectable : true));
    },
    fieldsfilter() {
      let ret = this.fieldscomputed
        .filter((f) => f.key !== "actions" && f.key !== "check")
        .map((m) => ({
          value: m.key || m || "novalue",
          text: m.label || m || "notext",
        }));
      ret.push({ value: "", text: " Todos" });
      return ret.sort((a, b) =>
        a.text.toUpperCase() < b.text.toUpperCase() ? -1 : 1
      );
    },
  },
  beforeMount() {
    this.filterfield = this.field;
  },
  methods: {
    onInput(value, eventname, timeout) {
      eventname = eventname || "input";
      timeout = timeout || this.delay || 0;

      if (timeout > 0) {
        if (this.inputtimeout) {
          clearTimeout(this.inputtimeout);
          this.timeoutinc--;
        }

        this.timeoutinc++;
        this.inputtimeout = setTimeout(() => {
          this.$emit(eventname, value);
          this.inputtimeout = null;
          this.timeoutinc--;
        }, timeout);
      } else {
        this.$emit(eventname, value);
      }
    },
  },
  watch: {
    value(value) {
      this.filter = value;
    },
    field(value) {
      this.$emit("onfilterfield", value);
    },
  },
};
</script>

<style scoped>
.groupitem {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>